<template>
  <div class="show-box">
    <a-tooltip :title="showLong(data[propName], 30)" placement="top">
      <div class="show">
        {{ ellipsis(data[propName], 30) }}
      </div>
    </a-tooltip>
  </div>
</template>


<script lang="ts" setup>
import {defineProps} from 'vue';
import {TextAreaFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: TextAreaFieldType;
  info: WidgetInfo;
  data: any;
}>();

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length > max) {
    return text;
  }
}

</script>


<style lang="scss" scoped>
.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: pre-line;
}
</style>
